import { of, switchMap, tap, catchError, EMPTY } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './ui.js';
import { acceptCollectionInvite } from './knowledge-api.js';

export function createAcceptInviteView(token) {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('accept-invite-view');
            replaceViewContainer(root);

            let accept$ = acceptCollectionInvite(token).pipe(
                tap(col => {
                    root.querySelector('h1').textContent = 'invite accepted';
                    root.querySelector('.accept-status').classList.add('hidden');
                    let successEl = root.querySelector('.accept-success');
                    successEl.querySelector('.collection-label').textContent = `${col.owner}/${col.name}`;
                    let link = successEl.querySelector('.collection-link');
                    link.href = `#collection/${col.id}`;
                    successEl.classList.remove('hidden');
                }),
                catchError(err => {
                    root.querySelector('.accept-status').classList.add('hidden');
                    let errorEl = root.querySelector('.accept-error');
                    let msg = 'Failed to accept invite.';
                    if (err && err.status === 400) {
                        msg = 'This invite is invalid, already used, or you cannot accept your own invite.';
                    } else if (err && err.status === 404) {
                        msg = 'Invite not found or expired.';
                    }
                    errorEl.querySelector('.error-message').textContent = msg;
                    errorEl.classList.remove('hidden');
                    return EMPTY;
                }),
            );

            return accept$;
        }),
    );
}
